var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"am-tabs-arrow-scroller"},[(_vm.arrowScroll)?_c('arrow',{attrs:{"icon":"keyboard_arrow_left"},on:{"click":_vm.scrollToFirst}}):_vm._e(),_c('div',{staticClass:"am-tabs-arrow-scroller--tabs"},[_vm._t("default")],2),(_vm.arrowScroll)?_c('arrow',{attrs:{"icon":"keyboard_arrow_right"},on:{"click":_vm.scrollToLast}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }